import React from 'react';
import PropTypes from 'prop-types';
import { Impression } from '@nerdwallet/analytics/react/impression';
import { Button, Text, Title } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';
import styles from './campaign-highlight.module.less';

const CampaignHighlight = ({
  backgroundColor,
  title,
  subtitle,
  ctaButtonText,
  ctaLinkUrl,
  visualBackgroundImageUrl,
  visualBackgroundImageAlt,
  elementImpressionEntityName,
  elementImpressionSectionName,
  trkQueryParam,
}) => (
  <Impression
    entityName={elementImpressionEntityName}
    payload={{ section_name: elementImpressionSectionName }}
  >
    <div className={styles.campaignHighlight}>
      <div className={styles.campaignHighlightCta} style={{ backgroundColor }}>
        <Title size="small" className={styles.campaignHighlightCtaTitle}>
          {title}
        </Title>
        <div className={styles.campaignHighlightCtaText}>
          <Text>{subtitle}</Text>
        </div>
        <Button
          href={`${ctaLinkUrl}?trk=${trkQueryParam}`}
          className={styles.campaignHighlightCtaButton}
        >
          {ctaButtonText}
        </Button>
      </div>
      <div
        className={styles.campaignHighlightVisualContainer}
        style={{ backgroundColor }}
      >
        <Image
          backgroundColor={backgroundColor}
          src={visualBackgroundImageUrl}
          alt={visualBackgroundImageAlt}
          imageClassName={styles.campaignHighlightVisualImage}
          lazy
        />
      </div>
    </div>
  </Impression>
);

CampaignHighlight.propTypes = {
  backgroundColor: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  ctaButtonText: PropTypes.string,
  ctaLinkUrl: PropTypes.string,
  visualBackgroundImageUrl: PropTypes.string,
  visualBackgroundImageAlt: PropTypes.string,
  elementImpressionEntityName: PropTypes.string,
  elementImpressionSectionName: PropTypes.string,
  trkQueryParam: PropTypes.string,
};

CampaignHighlight.displayName = 'CampaignHighlight';

export default CampaignHighlight;
